import './layout.css';

import React, { useRef, useState } from 'react';
import { NewVersion } from './NewVersion';
import { IntlProvider, LocalizationProvider } from '@progress/kendo-react-intl';
import { load, loadMessages } from '@progress/kendo-react-intl';
import weekData from 'cldr-core/supplemental/weekData.json';
import nbCaGregorian from 'cldr-dates-full/main/nb/ca-gregorian.json';
import nbDateFields from 'cldr-dates-full/main/nb/dateFields.json';
import nbMessages from '../../nb.json';
import Notifications from './Notifications';
import { AdaptiveActionSheet } from './adaptive/AdaptiveActionSheet';
import { DrawerMenu } from './menus/drawer/DrawerMenu';
import AppContainer from './app/AppContainer';
import Overlay from './overlay/Overlay';
import { useIsBusy } from '../hooks/useAppStore';

load(
    weekData,
    nbCaGregorian,
    nbDateFields
);
loadMessages(nbMessages, 'nb-NO');

function Layout({ children }) { 
    const menuRef = useRef();
    const newVersionRef = useRef();
    const selectedLocale = { language: 'nb-NO', locale: 'nb' };
    const [isNewVersionAvailable, setIsNewVersionAvailable] = useState(false);

    const isBusy = useIsBusy();

    return (
        <React.Fragment>
            <DrawerMenu
                ref={menuRef}
                newVersionRef={newVersionRef}
                isNewVersionAvailable={isNewVersionAvailable}
                setIsNewVersionAvailable={setIsNewVersionAvailable}>
                <LocalizationProvider language={selectedLocale.language}>
                    <IntlProvider locale={selectedLocale.locale}>
                        <Notifications />
                        <NewVersion
                            ref={newVersionRef}
                            isNewVersionAvailable={isNewVersionAvailable}
                            setIsNewVersionAvailable={setIsNewVersionAvailable}
                        />
                        <AppContainer menuRef={menuRef}>
                            {children}
                        </AppContainer>
                        <AdaptiveActionSheet />
                    </IntlProvider>
                </LocalizationProvider>
            </DrawerMenu>
            <Overlay isBusy={isBusy} showSpinner={true}/>
        </React.Fragment>
    );
}

export default Layout;
